export default __webpack_public_path__ + "static/media/43.2aacfdf9.png";